import { formatISO, parseISO, format } from "date-fns";
import LocalStorageService from "../../../../services/LocalStorageService";
import CoreService from "../../../../services/CoreService";


function getRandomColor() {
    var letters = '0123456789ABCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


function getLabelMapColor(label, colorMap) {
    var labelColor = colorMap.find((c) => c.name === label);
    var result = (labelColor) ? labelColor.id : getRandomColor();
    return result;
}


export default class ObservationLotReportManager {


    static async toGenericReportData(reportType, observations, colorMap, gcid, token) {
        var localStorageService = new LocalStorageService();
        var observation = observations[0];
        var schema = localStorageService.getSchema(observation.data.schema.id);
        var result = { gcid: gcid, observation: observation, schema: schema };
        return result;

    }

    static async toReportData(reportName, observations, colorMap, gcid, token, shared) {
        var localStorageService = new LocalStorageService();
        var coreService = new CoreService();
        var commodities = this.toDistinctCommodities(observations)
        var head = observations[0];
        var lot = {};
        lot.header =
        {
            runDate: { label: "As of", value: formatISO(new Date()) },
            runDateYyyyMmDd: { label: "As of", value: format(new Date(), "yyyy-MM-dd") },
            lot: { label: "Lot", value: head.data.UnderInspection.FamousLotNumber },
            supplier: { label: "Supplier", value: head.data.UnderInspection.Supplier },
            coo: { label: "Origin Country", value: head.data.UnderInspection.CountryOfOrigin },
            containerFacturaTransferNo: { label: "Reference", value: head.data.UnderInspection["ContainerFacturaTransfer#"] },
            arrivalDate: { label: "Date Received", value: head.data.UnderInspection.ArrivalDate },
            arrivalDateYyyyMmDd: { label: "Date Received", value: format(parseISO(head.data.UnderInspection.ArrivalDate), "yyyy-MM-dd") },
            location: { label: "Location", value: head.data.Raw.location },
            observationId: head.identifiers.id,
            observedBy: head.data.UnderInspection.Inspector,
            basketCount: head.data.Raw.basketcount
        };

        lot.commodities = [];
        for (var i = 0; i < commodities.length; i++) {
            var schema;
            if (shared) {
                var schemaResult = await coreService.fetchSchema(commodities[i], gcid, token);
                schema = schemaResult.dataResult;
            }
            else {
                schema = localStorageService.getSchema(commodities[i]);
            }

            var schemaReport = { commodity: commodities[i] };
            var filteredObservations = observations.filter((obs) => obs.data.schema.id === commodities[i]);
            schemaReport.totalCartons = { label: "Total Cartons", value: this.toTotalCartons(filteredObservations) };
            schemaReport.totalPallets = { label: "Total Pallets", value: this.toTotalPallets(filteredObservations) };
            schemaReport.gradeSummary = this.toGradeSummary(filteredObservations, schema, colorMap)
            schemaReport.detailLines = {};
            var detailSchema = this.toDetailSchema(schema);
            schemaReport.detailLines.schema = detailSchema;
            var detailRows = this.toDetailRows(filteredObservations, detailSchema, schema);
            schemaReport.detailLines.rows = detailRows;
            schemaReport.readings = this.toObservationReadings(filteredObservations, schema);
            schemaReport.comments = this.toObservationComments(filteredObservations);
            schemaReport.images = this.toObservationImages(filteredObservations);
            schemaReport.documents = this.toObservationDocuments(filteredObservations);

            schemaReport.header = lot.header;

            lot.commodities.push(schemaReport);
        }

        return lot;
    }


    static toObservationDocuments(observations) {
        var observationsWithDocs = observations.filter((observation) => { return (observation.data.Raw?.userdocs) });
        if (observationsWithDocs.length < 1) return [];
        var result = [];
        observationsWithDocs.forEach((observation) => {
            var obsDocs = observation.data.Raw?.userdocs.map((doc) => {
                return {
                    pallets: this.toPalletTagString(observation.data.UnderInspection?.SupplierPalletTag),
                    docFile: doc.id + "." + doc.ext,
                    thumbnailFile: (doc.thumbnailId) ? doc.thumbnailId + "." + "png" : "",
                    originalFileName: doc.descript,
                    description: doc.descript,
                    tags: []
                };
            });
            result = result.concat(obsDocs);
        });

        return result;
    }


    static toObservationImages(observations) {
        var observationsWithImages = observations.filter((observation) => { return (observation.data.Raw?.userimages) });
        if (observationsWithImages.length < 1) return [];
        var result = [];
        observationsWithImages.forEach((observation) => {
            var obsImages = observation.data.Raw?.userimages.map((img) => {
                return {
                    pallets: this.toPalletTagString(observation.data.UnderInspection?.SupplierPalletTag),
                    imageFile: img.id + "." + img.ext,
                    thumbnailFile: (img.thumbnailId) ? img.thumbnailId + "." + img.ext : "",
                    description: img.descript,
                    tags: img.tags
                };
            });
            result = result.concat(obsImages);
        });

        return result;
    }


    static toObservationComments(observations) {
        var observationsWithComments = observations.filter((observation) => { return (observation.data.Environment?.Comments) });
        if (observationsWithComments.length < 1) return [];
        var results = observationsWithComments.map((observation) => {
            var famousPalletTags = this.toPalletTagString(observation.data.UnderInspection?.FamousPalletTags);
            return { pallets: famousPalletTags, comments: observation.data.Environment.Comments };
        });
        return results;
    }

    static toObservationReadings(observations, schema) {
        // TBD - we don't currently support a section like this
        var result = [];
        result.push({ id: "pulptemperature", label: "Pulp Temperature Range", value: this.toRange(observations, "PulpTemperature", "Environment") });
        //result.push({id: "baxlomeasurements", label: "Baxlo Measurements Range", value: this.toRange(observations, "BaxloMeasurements", "Environment")});
        result.push({ id: "brixreading", label: "Brix Reading Range", value: this.toRange(observations, "BrixReading", "Environment") });
        result.push({ id: "temperaturerecording", label: "Temperature Recording Range", value: this.toRange(observations, "TemperatureRecording", "Environment") });
        // the following values are assumed to be the same on all observations of the same lot
        result.push({ id: "sealnumber", label: "Seal Number", value: observations[0].data.Environment.SealNumber });
        result.push({ id: "sealcondition", label: "Seal Condition", value: observations[0].data.Environment.SealCondition });
        result.push({ id: "curtaincondition", label: "Curtain Condition", value: observations[0].data.Environment.CurtainCondition });
        result.push({ id: "gas02reading", label: "Gas 02 Reading", value: observations[0].data.Environment.Gas02Reading });
        result.push({ id: "gasc02reading", label: "Gas C02 Reading", value: observations[0].data.Environment.GasC02Reading });

        result.push({ id: "requiredpallet", label: "Required Pallets", value: this.hasAny(observations, "requiredpallet") });
        result.push({ id: "palletid", label: "No Pallet ID", value: this.hasAny(observations, "palletid") });
        result.push({ id: "damagedpallets", label: "Damaged Pallets", value: this.hasAny(observations, "damagedpallets") });
        result.push({ id: "damagedboxes", label: "Damaged Boxes", value: this.hasAny(observations, "damagedboxes") });
        result.push({ id: "appearance", label: "Appearance", value: this.toUniqueString(observations, "appearance") });


        return result;


    }


    static toUniqueString(observations, prop) {
        var all = observations.map((observation) => { return (observation.data.Raw[prop]) ? observation.data.Raw[prop] : "" });
        var result = [...new Set(all)];
        return result.join(" ");
    }

    static toPalletTagString(palletTagValue) {
        if (!palletTagValue) return "";
        return (Array.isArray(palletTagValue)) ? palletTagValue.map((pt) => { return pt.famouspallet }).join(" / ") : palletTagValue;
    }

    static toRange(observations, propertyName, propertyPath) {
        var rangeValues = observations.map((observation) => { return observation.data[propertyPath][propertyName] });
        var max = Math.max(...rangeValues);
        var min = Math.min(...rangeValues);
        //return {min: min, max: max};
        var maxDisplay = (Number.isNaN(max)) ? "" : max;
        var minDisplay = (Number.isNaN(min)) ? "" : min;
        var hasDisplay = (!Number.isNaN(max) || (!Number.isNaN(min)));
        return (hasDisplay) ? minDisplay + "-" + maxDisplay : "not available";
    }


    static hasAny(observations, prop) {
        var result = observations.some((observation) => { return (observation.data.Raw[prop]) });
        return (result) ? "Yes" : "No";
    }


    static toDetailRows(observations, detailSchema, schema) {
        var result = [];
        observations.forEach((observation) => {
            var supplierPalletTag = observation.data?.Raw["supplier-pallet-tag"];
            if (!supplierPalletTag) {
                observation.data.Raw["supplier-pallet-tag"] = [];
                observation.data.Raw["supplier-pallet-tag"].push({ "supplierpallet": "", "famouspallet": "" });
            }
            else if (!Array.isArray(supplierPalletTag)) {
                // somehow we've got old data in here. Probably just a SINGLE value
                observation.data.Raw["supplier-pallet-tag"] = [];
                observation.data.Raw["supplier-pallet-tag"].push({ "supplierpallet": supplierPalletTag, "famouspallet": "" });
            }
            // FOR EACH Supplier/Famous Pallet combination we are going to create a row
            observation.data.Raw["supplier-pallet-tag"].forEach((pallet) => {

                var header = this.toRowHeader(observation, pallet, schema);
                // create an empty row of defects
                var rowDefects = [];
                detailSchema.forEach((dg) => {
                    var groupDefects = dg.schemaDefects.map((sd) => {
                        return { groupId: sd.groupId, groupLabel: sd.groupLabel, id: sd.id, label: sd.label, rawCount: 0, weightedMultiplier: 1, rawPct: 0, weightedPct: 0, value: 0 };
                    });
                    rowDefects = rowDefects.concat(groupDefects);
                });
                // fill in values for defects that actually have values
                observation.score.Score.GlobalDefects.ByDefect.forEach((defect) => {
                    var rowDefect = rowDefects.find((d) => (d.id === defect.cardId));
                    if (rowDefect) // might be in a different group
                    {
                        rowDefect.rawCount = defect.count;
                        rowDefect.weightedMultiplier = defect.weightedMultiplier;
                        rowDefect.rawPct = defect.rawPct;
                        rowDefect.weightedPct = defect.weightedPct;
                        rowDefect.value = defect.rawPct;
                        if (rowDefect.weightedPct < 0) {
                            rowDefect.weightedPct = 0
                        };
                        if ((rowDefect.weightedPct > 0) && (rowDefect.weightedPct < 1)) {
                            rowDefect.weightedPct = "<1";
                        }


                    }
                });
                var row = { header: header, defects: rowDefects };
                result.push(row);

            });

        });
        return result;
    }

    static toRowHeader(observation, supplierPalletTag, schema) {
        var result = [];
        result.push({ id: "supplierpallettag", label: "Supplier Pallet Tag", value: supplierPalletTag.supplierpallet });
        result.push({ id: "famouspallettag", label: "Famous Pallet Tag", value: supplierPalletTag.famouspallet });
        result.push({ id: "tracecode", label: "Traceability Code", value: observation.data.Raw.tracecode });
        result.push({ id: "packstyle", label: "Pack Style", value: observation.data.Raw.packstyle });
        result.push({ id: "label", label: "Label", value: observation.data.Raw.label });
        result.push({ id: "Pack Date", label: "Pack Date", value: (observation.data.Raw.packdate) ? format(parseISO(observation.data.Raw.packdate), 'MM/dd/yyyy') : "" });
        result.push({ id: "varietycode", label: "Variety", value: observation.data.Raw.varietycode });
        result.push({ id: "method", label: "Method", value: observation.data.Raw.method });
        result.push({ id: "totalboxes", label: "Boxes", value: observation.data.Raw.totalBoxes });
        result.push({ id: "underweight", label: "Underweight", value: this.toUnderweightPct(observation.data.Raw.underweight, observation.data.Raw.basketCount) });
        result.push({ id: "appearance", label: "Appearance", value: observation.data.Environment.Appearance });
        if (observation.data.schema.id === 'BLUEBERRY') {
            result.push({ id: "baxlomeasurements", label: "Baxlo Measurement", value: observation.data.Raw.baxlomeasurements });
        }
        if (observation.score.Score.Grade.WeightedScore) {
            result.push({ id: "score", label: "Score", value: observation.score.Score.Grade.WeightedScore.toFixed(1) });
        } else {
            result.push({ id: "score", label: "Score", value: '<50' });
        }
        return result;
    }

    static toUnderweightPct(underweightDefects, basketCount) {
        if ((!underweightDefects) || (!basketCount)) return "";
        if (underweightDefects === 0) return "";
        if (basketCount === 0) return "";
        if (underweightDefects === "") return "";
        if (underweightDefects === "0") return "";
        let result = Math.round((underweightDefects / basketCount) * 100);
        return result.toString();
    }


    static toDetailSchema(schema) {
        var result = [];
        var defectGroups = this.toDefectGroups(schema);
        defectGroups.forEach((dg) => {
            var schemaDefectGroup = schema.categories.find((cat) => cat.id === 'defects').groups.find((schemaGroup) => schemaGroup.id === dg.id);
            var schemaDefects = schemaDefectGroup.cards.map((card) => { return { groupId: dg.id, groupLabel: dg.label, id: card.id, label: card.title } });
            result.push({ schemaGroup: dg, schemaDefects: schemaDefects });
        });

        return result;
    }



    // assumes you've filtered observations to commodity
    static toGradeSummary(observations, schema, colorMap) {
        // use the schema to drive the grades
        var grades = schema.scoring.gradeGradient.map((g) => { return { grade: g.grade, label: g.title, description: g.description, rangeDescription: g.rules[0].rangeDescription, color: getLabelMapColor(g.title, colorMap), cutoff: g.rules[0].weightedCutoff } });
        var cutoff = schema.scoring.cutoffGrade;
        if (cutoff) {
            grades.push({ grade: cutoff.grade, label: cutoff.title, description: cutoff.description, rangeDescription: cutoff.rangeDescription, color: getLabelMapColor(cutoff.title, colorMap), cutoff: "<" + grades[grades.length - 1].cutoff });
        }
        // get to defect groups
        var defectGroups = this.toDefectGroups(schema);



        for (var i = 0; i < grades.length; i++) {
            var grade = grades[i];
            // NOTE that I'm using RAW grade here. Otherwise the weighted grade percentages won't make any sense. I guess I could use the weighted percent to do this but then you get things like half a berry count?
            var filteredObservations = observations.filter((obs) => obs.score.Score.Grade.Weighted === grade.label);
            if (filteredObservations.length === 0) {
                // none of the observations for this commodity got this grade
                // fill an empty value for each defect group
                grade.cartons = { label: "Cartons", value: 0 };
                grade.pallets = { label: "Pallets", value: 0 };
                grade.defectGroups = [];
                defectGroups.forEach((dg) => {
                    //grade[dg.id] = {label: dg.label, totalCount: 0, defectCount: 0, value: 0};
                    var groupDefectCounts = this.toTotalDefectGroupCounts(filteredObservations, dg);
                    grade.defectGroups.push({ label: dg.label, value: groupDefectCounts.value, details: groupDefectCounts });
                });

            }
            else {
                // there ARE values in group
                grade.cartons = { label: "Cartons", value: this.toTotalCartons(filteredObservations) };
                grade.pallets = { label: "Pallets", value: this.toTotalPallets(filteredObservations) };
                grade.defectGroups = [];
                defectGroups.forEach((dg) => {
                    var groupDefectCounts = this.toTotalDefectGroupCounts(filteredObservations, dg);
                    grade.defectGroups.push({ label: dg.label, value: groupDefectCounts.value, details: groupDefectCounts });
                });

            }
        }
        return grades;
    }

    static toDefectGroups(schema) {
        var defectCategory = schema.categories.find((cat) => cat.id === 'defects');
        var result = defectCategory.groups.filter((g) => g.defectCategory === true).map((dg) => { return { id: dg.id, label: dg.groupTitle } });
        return result;
    }

    static toTotalDefectGroupCounts(observations, defectGroup) {
        var result = { "rawCount": 0, "weightedMultiplier": 1, "rawPct": 0, "weightedPct": 0, "totalCount": 0, "score": 100, "value": 0 };
        if (observations.length < 1) return result;
        for (var i = 0; i < observations.length; i++) {
            var obsCategoryData = observations[0].score.Score.GlobalDefects.ByCategory.find((c) => c.category === defectGroup.id);
            if (obsCategoryData) {
                result = { "rawCount": result.rawCount + obsCategoryData.value, "weightedMultiplier": obsCategoryData.weightedMultiplier, "totalCount": result.totalCount + observations[0].score.Score.TotalInspected };
            }
        }
        // now calculate the raw "count"
        if (result.rawCount > 0) {
            let rawPct = Math.round((result.rawCount / result.totalCount) * 100);
            let weightedPct = Math.round((rawPct * result.weightedMultiplier));
            result.rawPct = rawPct;
            result.weightedPct = weightedPct;
            result.score = Math.min(100, (100 - rawPct));
            result.value = rawPct;
        }
        return result;
    }

    static toDistinctCommodities(observations) {
        var all = observations.map((o) => o.data.schema.id);
        var result = [...new Set(all)];
        return result;
    }

    static toTotalCartons(observations) {
        var result = 0;
        for (var i = 0; i < observations.length; i++) {
            let incrementer = (observations[i].data.UnderInspection?.TotalBoxes) ? parseInt(observations[i].data.UnderInspection.TotalBoxes) : 0;
            result = result + incrementer;
        }
        return result;
    }

    static toTotalPallets(observations) {
        var result = 0;
        var uniquePallets = [];
        // get ALL supplier pallet tags
        for (var i = 0; i < observations.length; i++) {
            let palletTags = observations[i].data.UnderInspection.PalletTags ?? [];
            var palletTagNbrs = palletTags.map((p) => { return p.supplierpallet });
            palletTagNbrs.forEach((pt) => {
                if (!uniquePallets.includes(pt)) {
                    uniquePallets.push(pt);
                }
            });
        }
        var result = uniquePallets.length;
        return result;
    }



}


